import { render, staticRenderFns } from "./PropuestaEcoListP.vue?vue&type=template&id=553a174e&scoped=true&"
import script from "./PropuestaEcoListP.vue?vue&type=script&lang=js&"
export * from "./PropuestaEcoListP.vue?vue&type=script&lang=js&"
import style0 from "./PropuestaEcoListP.vue?vue&type=style&index=0&id=553a174e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a174e",
  null
  
)

export default component.exports